<div class="modal-header">
    <h3 class="modal-title text-modal-header-bold" id="modal-basic-title">Búsqueda de documentos </h3>
    <button type="button" class="close" aria-label="Close" (click)="cancelar()" tabindex="211">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form>
        <div class="row">
            <div class="col-md-12">
                <div class="row mt-3" style="margin-top:15px !important">
                    <div class="col-md-12">
                        <div class="table-responsive" style="height: 75vh;">
                            <table class="table table-striped table-bordered table-sm row-border hover nowrap" >
                                <thead>
                                    <tr>
                                        <th style="text-align: left;"></th>
                                        <th style="text-align: left;"> Numint </th>
                                        <th style="text-align: left;"> Serie</th>
                                        <th style="text-align: left;"> Número </th>
                                        <th style="text-align: left;"> Fecha </th>
                                        <th style="text-align: center;"> Tipo documento </th>
                                        <th style="text-align: center;"> Cliente </th>
                                        <th style="text-align: center;"> Motivo </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="cursor" *ngFor="let lst of listadata; index as i"
                                        [ngClass]="{'color-row': position == i}">
                                        <td    style="text-align: center;">
                                            <input type="radio" (change)="onChangeItem(lst)" tabindex="13" name="radio">
                                        </td>
                                        <td style="text-align: left;"> {{ lst.numint }} </td>
                                        <td style="text-align: left;"> {{ lst.series }} </td>
                                        <td style="text-align: left;"> {{ lst.numdoc }} </td>
                                        <td style="text-align: left;"> {{ lst.femisi | date:'dd/MM/yyyy' }} </td>
                                        <td style="text-align: left;"> {{ lst.desdoc }} </td>
                                        <td style="text-align: left;"> {{ lst.razonc }} </td>
                                        <td style="text-align: left;"> {{ lst.desmot }} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

</div>

<div class="modal-footer">

    <button type="button" class="btn btn-rounded btn-success m-b-15" [disabled]="!ItemSeleccionado"
        (click)="openModalAdicionar()" tabindex="205">
        <i class=" fas fa-angle-double-right"></i> Continuar </button>
    <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="cancelar()"
            tabindex="6"><i class="fa fa-times-circle"></i> Cancelar</button>

</div>